import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import NacaPartnerPage from "@/pages/partners/Naca";

export const Route = createFileRoute("/partners/naca")({
  head: () => seoHead("/partners/naca"),
  component: NacaPartnerPage,
});
